import { combineReducers } from '@reduxjs/toolkit'

import { reducer as questions } from './questions'
import { reducer as plans } from '../plan/plan'
import { reducer as menus } from './menus'
import { reducer as precautions } from './precaution'
import { reducer as backFlow } from './backFlow'

export default combineReducers({
  questions,
  plans,
  menus,
  precautions,
  backFlow,
})
